import GeoLocation from '@/mixins/geo/geoLocation'

export default {
  mixins: [GeoLocation],

  data() {
    return {
      geoLocationOptions: {
        autoStart: false,
        callback : 'setGeoLocationData',
        watchID  : null
      }
    }
  },

  created() {
    if (!this.geoLocationOptions.autoStart) return
    this.startAutoWatchGeoLocation()
  },

  beforeDestroy() {
    this.stopAutoWatchGeoLocation()
  },

  methods: {
    async startAutoWatchGeoLocation() {
      await this.stopAutoWatchGeoLocation()

      try {
        const coordinates = await this.watchGeoLocation()

        if (typeof this.geoLocationOptions.callback === 'function') {
          this.geoLocationOptions.callback(coordinates)
        } else if (typeof this.geoLocationOptions.callback === 'string') {
          if (typeof this[this.geoLocationOptions.callback] === 'function') {
            this[this.geoLocationOptions.callback](coordinates)
          }
        }
      } catch (e) {

        console.error(e)
      }
    },

    async stopAutoWatchGeoLocation() {
      try {
        await this.clearGeoLocation()
      } catch (e) {

        console.error(e)
      }
    },

    setGeoLocationData(coordinates) {

      console.log('setGeoLocationData:', coordinates)

      window.callAS(window.SocketCommand.Staff.Delivery.SaveGeo, {Geo: coordinates})
    }
  }

}
